import { GetFolders, GetFolderToken } from "$src/application/customers/queries/GetFolders";
import { Folder } from "$src/domain/customers/Folder";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function fetchFolders(groupStoreId: number, customerId: number): Promise<Folder[]> {
   
    const query = container.resolve<GetFolders>(GetFolderToken);
    return query.execute(groupStoreId, customerId);
}

export function useFolders(groupStoreId: number, customerId: number) {

    return useQuery<Folder[], Error>({
        queryKey: ['folders', customerId],
        queryFn: () => fetchFolders(groupStoreId, customerId),
        staleTime: 300000,
        cacheTime: 600000,
    });
}
